import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.scss";
import { useDeviceType } from "@/hooks/useDeviceType"

const ThreePanelFeature = ({ threePanelFeatureData = {} }) => {
  const {
    title: Title,
    description: Description,
    images = [],
    cta = {},
    showTrends = false
  } = threePanelFeatureData;

  const { isDesktop } = useDeviceType();
  let imageCount = 2;
  
  if (!isDesktop && showTrends) { 
    imageCount = 1
  }

  const { label = "", url = "" } = cta.fields || {};

  const imagesArray = images.map(item => ({
    src: item.fields?.imageUrl,
    alt: item.fields?.internalTitle || ""
  })).filter(img => img.src);




  let textClass = showTrends ? styles.textContent : styles.content;
  let wrapperClass = showTrends ? styles.trendsWrapper : styles.wrapper;
  return (
    <section className={styles.section}>
      <div className={wrapperClass}>
        {/* Two Images */}
        {showTrends ?
          <div className="flex justify-items-center justify-center gap-10">
            {imagesArray.slice(0, imageCount).map((image, index) => (
              <div className={styles.imageWrapper} key={index}>
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </div> : <>
            {imagesArray.slice(0, imageCount).map((image, index) => (
              <div className={styles.imageWrapper} key={index}>
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </>
        }
        {/* Text Panel */}
        <div className={textClass}>
          <div className={styles.twoImgTitle}>{Title}</div>
          <p className={styles.twoImgDescription}>{Description}</p>
          {label && url && (
            <button
            type="button"
            className={styles.button}
            aria-label={label}
            onClick={() => {
              window.location.href = url;
            }}
          >
  {label}
</button>

          )}
        </div>
      </div>
    </section>
  );
};

ThreePanelFeature.defaultProps = {
  threePanelFeatureData: {
    title: "",
    description: "",
    images: [],
    cta: {
      fields: {
        label: "",
        url: ""
      }
    }
  }
};


const imagePart = (imagesArray) => {
  return (
    imagesArray.slice(0, imageCount).map((image, index) => (
              <div className={styles.imageWrapper} key={index}>
                <img src={image.src} alt={image.alt} />
              </div>
    )))
}

export default ThreePanelFeature;

ThreePanelFeature.propTypes = {
  threePanelFeatureData: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          imageUrl: PropTypes.string.isRequired,
          internalTitle: PropTypes.string
        }).isRequired
      })
    ),
    cta: PropTypes.shape({
      fields: PropTypes.shape({
        label: PropTypes.string,
        url: PropTypes.string,
        ariaLabel: PropTypes.string,
        visible: PropTypes.bool
      })
    })
  })
};